import { GRID_MESSAGE_KEYS_OVERRIDES } from "../grid/utils/message-keys-overrides";

export const MESSAGE_KEY_OVERRIDES: Record<string, string> = {
  ...GRID_MESSAGE_KEYS_OVERRIDES,
};
